if (window.location.href.includes('products')) {
  productImageSwatches();
  productImageZoom();
}

function openProductImageZoom(index) {
  if (window.__vueEventBus) {
    window.__vueEventBus.$emit('openProductImageZoom', index);
  }
}

function productImageZoom() {
  window.addEventListener('load', function() {
    var mainImage = document.querySelector('.product-images .image img.product-image');
    if (!mainImage) return;

    mainImage.addEventListener('click', function() {
      if (mainImage.classList.contains('hidden')) return;
      var index = parseInt(mainImage.getAttribute('data-index'), 10);
      openProductImageZoom(isNaN(index) ? 0 : index);
    });
  });
}

function productImageSwatches() {
  window.addEventListener('load', function() {
    if (document.querySelector('.product-thumbnail')) {
      document
        .querySelector('.product-thumbnail')
        .classList.add('border-secondary', 'border');
      document.querySelector('.product-thumbnail').classList.remove('border');
      document
        .querySelectorAll('.product-thumbnail')
        .forEach(function(thumbnail) {
          thumbnail.addEventListener('click', function(e) {
            document
              .querySelectorAll('.product-thumbnail')
              .forEach(function(thumbnail) {
                thumbnail.classList.remove('border-active');
              });
            var newImageUrl = e.target.dataset.imageUrl;
            var newVideoUrl = e.target.dataset.videoUrl;
            var newExternalVideoUrl = e.target.dataset.externalVideoUrl;
            var newIndex = e.target.dataset.index;
            e.target.classList.add('border-active');
            e.target.classList.remove('border');
            if (thumbnail.nodeName === 'VIDEO') {
              document.querySelector('.product-video').src = newVideoUrl;
              document
                .querySelector('.product-video')
                .classList.remove('hidden');
              document.querySelector('.product-image').classList.add('hidden');
              document
                .querySelector('.product-video-external')
                .classList.add('hidden');
            } else if (e.target.dataset.externalVideoUrl) {
              document.querySelector(
                '.product-video-external'
              ).src = newExternalVideoUrl;
              document
                .querySelector('.product-video-external')
                .classList.remove('hidden');
              document.querySelector('.product-image').classList.add('hidden');
              document.querySelector('.product-video').classList.add('hidden');
            } else {
              document
                .querySelector('.product-image')
                .setAttribute('src', newImageUrl);
              document
                .querySelector('.product-image')
                .setAttribute('data-index', newIndex);
              document
                .querySelector('.product-image')
                .classList.remove('hidden');
              document.querySelector('.product-video').classList.add('hidden');
              document
                .querySelector('.product-video-external')
                .classList.add('hidden');
            }
          });
        });
    }
  });
}
